import scrollParent from '../../../services/scroll-parent';

const GAP_SIZE = 32;
const GAP_TOP_SIZE = 6;

export default function getInlineToolbarPosition(editorRect, targetRect, toolbarRect) {
  const parentRect = scrollParent().getBoundingClientRect();
  const minLeft = GAP_SIZE - editorRect.left;
  const maxLeft = parentRect.width - editorRect.left - toolbarRect.width - GAP_SIZE;

  const left = targetRect.left - editorRect.left + targetRect.width / 2 - toolbarRect.width / 2;
  const top = targetRect.top - editorRect.top - toolbarRect.height - GAP_TOP_SIZE;

  return {
    left: Math.min(Math.max(left, minLeft), maxLeft),
    top,
  };
}



// WEBPACK FOOTER //
// ./app/components/text-editor/utils/get-toolbar-position.js